export default "__VITE_ASSET__DO_UZz_8__"